export const PERIOD_LENGTH_15_MIN = 15 * 60;
export const PERIOD_LENGTH_10_MIN = 10 * 60;
